// CLASSES
import AppConfig from "@classes/AppConfig";
import Validator from "../../../../../classes/Validator";
import Orderinstruktion from "./Orderinstruktion";

export default function(props, state)
{
	if (AppConfig.get("developmentOptions").ignoreFullfillment === true)
	{
		return true;
	}

	const {fields} = state;

	if (state.isLoading)
	{
		return false;
	}

	if (state.showError !== false)
	{
		return false;
	}

	if (fields.advice_instruction_account_type.length <= 0 ||
		fields.advice_instruction_account_number.length <= 0 ||
		fields.advice_instruction_account_owner.length <= 0 ||
		fields.advice_instruction_transaction_currency.length !== 3)
	{
		return false;
	}

	// we need to have at least one active product
	let numberOfActiveProducts = 0;
	for (let i = 0; i < Orderinstruktion.ALLOWED_PRODUCTS_COUNT; i++)
	{
		const transactionType = state.caseData["recommendation_product_type_" + i];
		if (transactionType !== undefined && transactionType !== "") {
			numberOfActiveProducts++;
		}
	}
	if (numberOfActiveProducts === 0) {
		return false;
	}

	let signatoryCheckFailed = false;
	fields.signatories.forEach(function(s)
	{
		if (s.firstName.length <= 0 ||
			s.lastName.length <= 0 ||
			!Validator.validateSsn(s.ssn) ||
			!Validator.validateEmail(s.email))
		{
			signatoryCheckFailed = true;
			return false;
		}
	});

	if (signatoryCheckFailed)
	{
		return false;
	}

	return true;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Citroneer/orderinstruktion/Orderinstruktion.fulfillment.js